/**
 * 通用表单基本组件的配置信息
 * 详细范例https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=102786580
 * 拥有以下属性：
 * uuid         组件全局ID
 * label        标签文字
 * output       相对输出位置（输出值对应的键名）
 * component    组件类型（枚举值见../register中的COMPONENT_MAP）
 * props {}     组件属性
 * deps[]       组件依赖
 */

import uuid from 'uuid/v1';
import cloneDeep from 'lodash/cloneDeep';
import ComponentConfigDep from './component-config-dep';

class ComponentConfig {
    constructor(config = {}, { uuidFallback } = {}) {
        config = cloneDeep(config);
        // 检查config中的字段是否完整
        if (typeof config.uuid !== 'string' || !config.uuid) {
            // 一般不可能出现没有uuid的情况，因为组件注册需要uuid
            // this._warn('[config.uuid] must be a non-empty string');
            config.uuid = uuidFallback || uuid();
        }

        if (typeof config.label !== 'string') {
            // this._warn('[config.label] must be a string');
            config.label = '';
        }

        if (typeof config.output !== 'string') {
            // this._warn('[config.output] must be a string');
            config.output = '';
        }

        if (typeof config.component !== 'string') {
            // this._warn('[config.component] must be a string');
            config.component = '';
        }

        if (typeof config.props !== 'object') {
            // this._warn('[config.props] must be an object');
            config.props = {};
        }

        if (!Array.isArray(config.deps)) {
            // this._warn('[config.deps] must be an array');
            config.deps = [];
        }

        // 初始化
        this.init(config);
    }

    _warn(msg = 'Invalid config info.') {
        // eslint-disable-next-line
        console.warn(msg);
    }

    init(config) {
        this.uuid = config.uuid;
        this.label = config.label;
        this.output = config.output;
        this.component = config.component;
        this.props = config.props;
        this.deps = [];
        config.deps.forEach(dep => {
            this.deps.push(new ComponentConfigDep(dep));
        });
    }

    getConfigObj() {
        return {
            uuid: this.uuid,
            label: this.label,
            output: this.output,
            component: this.component,
            props: cloneDeep(this.props),
            deps: cloneDeep(this.deps),
        };
    }
}

export default ComponentConfig;
